/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-02 17:08:54
 * @FilePath: /vise/packages/app-share/src/constants/player-info.ts
 */
export enum EPosterTag {
  posterAvatar = 'poster_avatar',
  posterNick = 'poster_nick',
  posterFollow = 'poster_follow',
}

export enum EInfoTag {
  topic = 'topic',
  person = 'person',
  desc = 'desc',
}

export enum EControlTag {
  collectionIcon = 'collection_icon',
  likeIcon = 'like_icon',
  commentIcon = 'comment_icon',
  shareIcon =  'share_icon',
}

export enum ELabelTag {
  music = 'music',
  geo = 'geo',
}
